@let state = $state().type;
@let paginationMeta = $paginationMeta();
<div class="actions-container" *ngIf="tableOptions.enableControls">
  <div class="selection" *ngIf="tableOptions.enableSelection">
    <ub-label
      text="{{selectedRowsCount === 0 ? 'No' : selectedRowsCount}} {{selectedRowsCount === 1 ? tableOptions.itemSingleLabel : tableOptions.itemPluralLabel}} selected"
      variant="none" i18n-text></ub-label>
    <button *ngIf="selectedRowsCount > 0 && paginationMeta.total !== selectedRowsCount" mat-button color="accent" (click)="onResetSelection()" i18n>
      Deselect all
    </button>
  </div>

  <ng-container *ngIf="easForm">
    <form [formGroup]="easForm.control" class="quicksearch">
      <eas-easform-control-single *ngFor="let control of easForm.controls" [easControl]="control" class="filter"></eas-easform-control-single>
    </form>
  </ng-container>

  <div class="controls">
    <button mat-icon-button color="accent" (click)="onRefresh()"
      [attr.aria-label]="'Refresh the table with new ' + tableOptions.itemPluralLabel" i18n-aria-label>
      <mat-icon>refresh</mat-icon>
    </button>
    <button *ngIf="tableOptions.enableFilters && haveFilters" mat-stroked-button matBadge="{{ filtersCount$ | async }}" class="setting-button" (click)="onComponentVisibilityChange('filtersSelector')" [attr.id]="filtersButtonId" [attr.aria-controls]="filtersPanelId" [attr.aria-expanded]="showFiltersSelector" [attr.aria-label]="getButtonAriaLabel('Filters', filtersCount$ | async)"><mat-icon>filter_list</mat-icon> <span i18n="filters">Filters</span></button>
    <button mat-stroked-button matBadge="{{selectedColumns.length - 1}}" class="setting-button" (click)="onComponentVisibilityChange('columnsSelector')" *ngIf="tableOptions.enableColumns && allAvailableColumns" [attr.id]="columnsButtonId" [attr.aria-controls]="columnsPanelId" [attr.aria-expanded]="showColumnsSelector" [attr.aria-label]="getButtonAriaLabel('Columns', selectedColumns.length - 1)"><mat-icon>view_column</mat-icon> <span i18n="columns">Columns</span></button>
    <button *ngIf="tableOptions.enableExport" mat-stroked-button class="setting-button" (click)="onComponentVisibilityChange('tableExports')" [attr.id]="exportButtonId" [attr.aria-controls]="exportPanelId" [attr.aria-expanded]="showTableExports"><mat-icon>cloud_download</mat-icon> <span i18n>Export All</span></button>
  </div>
</div>

<eas-filters-selector
  *ngIf="showFiltersSelector"
  [itemLabels]="itemLabels"
  [attr.id]="filtersPanelId"
  [attr.aria-labelledby]="filtersButtonId"
  i18n-itemLabels
  >
</eas-filters-selector>

<eas-columns-selector
  *ngIf="showColumnsSelector"
  [attr.id]="columnsPanelId"
  [attr.aria-labelledby]="columnsButtonId"
  [defaultColumns]="defaultColumns"
  [allAvailable]="allAvailableColumns"
  [selected]="selectedColumns"
  (selectedApplied)="onColumnSelected($event)">
</eas-columns-selector>

<eas-table-exports
  [itemLabels]="itemLabels"
  [attr.id]="exportPanelId"
  [attr.aria-labelledby]="exportButtonId"
  *ngIf="showTableExports"
  [total]="paginationMeta.total">
</eas-table-exports>

<p *ngIf="tableOptions.enableSelection && isAllRowsInPageChecked && isManuallySelectingRows && selectedRowsCount < paginationMeta.total">
  <span i18n>All {{paginationMeta.size}} {{tableOptions.itemPluralLabel}} on this page are selected.</span>
  <button mat-button color="accent" (click)="onSelectAllRowMatchingSearch()" i18n>
    Select all {{paginationMeta.total}} {{tableOptions.itemPluralLabel}} that match this search
  </button>
</p>

<p *ngIf="!isManuallySelectingRows">
  <span i18n>All {{selectedRowsCount}} {{tableOptions.itemPluralLabel}} that match this search are selected.</span>
  <button mat-button color="accent" (click)="onResetSelection()" i18n>
    Deselect all
  </button>
</p>

<div role="region" aria-live="polite" aria-relevant="text additions"
  [attr.aria-label]="tableOptions.tableTitle + ' search results'">
  <p *ngIf="tableOptions.enableControls && tableOptions.enableFilters">
    <span *ngIf="searchText$ | async; let searchText" [innerHtml]="searchText"></span>
  </p>
</div>

<p class="controls-alert" *ngIf="state === 'empty'" i18n>
  We couldn't find any {{tableOptions.itemPluralLabel}}.
</p>

<p class="controls-alert" *ngIf="state === 'error'" i18n>
  <!-- FIXME: Better error here... -->
  Error loading {{tableOptions.itemPluralLabel}}: {{ $state().error }}
</p>

<div class="mat-table-container" [ngClass]="state === 'loading' || state === 'pending' ? 'table-loading' : ''">
  <div class="loading-spinner" *ngIf="state === 'loading' || state === 'pending'">
    <mat-spinner color="accent" strokeWidth="2" diameter="25"></mat-spinner>
  </div>
  <table mat-table
    [dataSource]="tableRows"
    matSort
    matSortDisableClear
    cdkDropList
    fixedLayout
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="tableDrop($event)"
    [attr.aria-label]="tableOptions.tableTitle"
  >
    <ng-container *ngIf="tableOptions.enableSelection" matColumnDef="select" sticky>
      <th mat-header-cell *matHeaderCellDef width="12em">
        <label>
          <span class="sr-only" i18n>{{isAllRowsInPageChecked ? 'Deselect' : 'Select'}} all</span>
          <mat-checkbox [checked]="isAllRowsInPageChecked" (change)="onSelectAllRowsInPage()" [disabled]="!isManuallySelectingRows"></mat-checkbox>
        </label>
      </th>
      <td mat-cell *matCellDef="let row">
        <label>
          <span class="sr-only" i18n>{{isRowSelected(row.id) ? 'Deselect' : 'Select'}} row {{row.readableId}}</span>
          <mat-checkbox
            [checked]="isRowSelected(row.id)"
            (change)="$event ? onRowSelected(row.id) : null"
            [disabled]="!isManuallySelectingRows"
          >
          </mat-checkbox>
        </label>
      </td>
    </ng-container>

    <ng-container *ngFor="let column of selectedColumnsDef; let isFirst = first" [matColumnDef]="column.id" [stickyEnd]="column.stickyEnd">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!column.sortable"
        scope="col"
        cdkDrag
        cdkDragLockAxis="x"
        cdkDragBoundary="mat-header-row"
      >
        {{column.label}}
      </th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="isFirst && row.row.error" class="error">{{ row.row.error }}</span>
        <span [style.margin-left.px]="isFirst && row.row.__indent__ !== undefined ? row.row.__indent__ * 30 : 0">
          <ng-container *ngIf="row.row[column.id] != undefined">
            <ng-container [ngSwitch]="column.type">
              <ng-container *ngSwitchCase="'date'">
                {{ row.row[column.id] | date }}
              </ng-container>
              <ng-container *ngSwitchCase="'dateRange'">
                {{ row.row[column.id] | easDateRange }}
              </ng-container>
              <ng-container *ngSwitchCase="'timeFromNow'">
                {{ row.row[column.id] | easDateFromNow }}
              </ng-container>
              <ng-container *ngSwitchCase="'price'">
                <span *ngIf="row.row[column.id]">
                  {{ row.row[column.id]['amount'] | currency:row.row[column.id]['currency'] }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'priceRange'">
                {{ row.row[column.id] | easPriceRange:row.row[column.id].currency }}
              </ng-container>
              <ng-container *ngSwitchCase="'datetime'">
                {{ row.row[column.id] | date:'medium' }}
              </ng-container>
              <ng-container *ngSwitchCase="'link'">
                <a [routerLink]="[row.row[column.id]?.relative]" [queryParams]="row.row[column.id]?.queryParams" [attr.aria-label]="column.label + ' ' + row.readableId">{{ column.label }}</a>
              </ng-container>
              <ng-container *ngSwitchCase="'button'">
                <button mat-flat-button color="primary" (click)="onClick(column, row)" [attr.aria-label]="column.label + ' ' + row.readableId">{{ row.row[column.id].label ?? column.label }}</button>
              </ng-container>
              <ng-container *ngSwitchCase="'modal'">
                <button mat-stroked-button color="accent" (click)="openModal(column, row.row[column.id])" [attr.aria-label]="column.label + ' ' + row.readableId">{{ column.label }}</button>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ row.row[column.id] }}
              </ng-container>
            </ng-container>
          </ng-container>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: selectedColumns;"></tr>
  </table>
</div>

<mat-paginator style="text-align: right;"
  *ngIf="tableOptions.enablePagination && paginationMeta && paginationMeta.total > 5"
  (page)="onPageChange($event)"
  [length]=paginationMeta.total
  [pageSize]=list.pageSize
  [pageSizeOptions]="[5, 10, 20, 50, 100]"
  showFirstLastButtons>
</mat-paginator>

<p *ngIf="paginationMeta.total <= 5 && paginationMeta.total > 0">
  {{paginationMeta.total}} of {{paginationMeta.total}} {{tableOptions.itemPluralLabel}}
</p>
